import styled, { css } from "styled-components";
import { BLACK_BG, content, medium, WHITE_BG } from "../common/styles/mixins";

export const Content = styled.div.attrs({ className: "content" })`
  h1 {
    font-size: 1.75em;
    ${medium(css`
      font-size: 2.5em;
    `)}
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
  padding-bottom: 2.5em;
`;

export const makeBanner = (c: any) => styled(c)`
  margin-bottom: -1.5em;
`;

export const Container = styled.div`
  padding: 2em;
  width: fit-content;
  margin: auto;
  text-align: center;
  margin-bottom: 1em;
  ${medium(css`
    p {
      max-width: 60ch;
    }
  `)}
`;

export const Main = styled.main`
  ${content({
    extraLarge: 900,
    large: 900,
  })}
  min-height: calc(100vh - 120px);
`;

const FOCUSED_COLORS = css`
  color: ${BLACK_BG};
  background-color: ${WHITE_BG};
`;

export const CategoryTag = styled.div<{ selected?: boolean }>`
  display: inline;
  padding: 0.3em 0.9em;
  border-radius: 160px;
  border-color: ${WHITE_BG};
  border: 2px solid;
  cursor: pointer;
  font-family: "Bebas Neue Pro Expanded";
  text-transform: uppercase;
  font-size: 1.2em;
  letter-spacing: 1px;
  &:hover {
    ${FOCUSED_COLORS}
  }
  transition: all 0.1s linear;
  ${(props) => (props.selected ? FOCUSED_COLORS : "")}
`;

export const TagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.3em;
`;

export const ARTIST_AVATAR_SIZE = 170;
export const ArtistContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  a {
    display: block;
  }
  h3 {
    margin: 0;
    margin-top: 0.5em;
    font-size: 1.5em;
    &:first-letter {
      font-size: 1.25em;
    }
    display: block;
  }
  .artist {
    margin-bottom: 2em;
  }
  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  div.inner > div {
    box-shadow: none !important;
    border: 2px solid white;
  }
`;

export const Input = styled.input.attrs({
  type: "text",
  name: "search",
  id: "search",
  placeholder: "Search",
})`
  font-family: "Bebas Neue Pro Expanded";
  /* font-weight: 600; */
  font-size: 1.25em;
  width: 100%;
`;
